/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AccessRequestsRequestBuilderNavigationMetadata, type AccessRequestsRequestBuilder } from './accessRequests/index.js';
// @ts-ignore
import { ActiveCustomersRequestBuilderRequestsMetadata, type ActiveCustomersRequestBuilder } from './activeCustomers/index.js';
// @ts-ignore
import { AovRequestBuilderRequestsMetadata, type AovRequestBuilder } from './aov/index.js';
// @ts-ignore
import { CartsRequestBuilderNavigationMetadata, type CartsRequestBuilder } from './carts/index.js';
// @ts-ignore
import { CategoriesRequestBuilderNavigationMetadata, type CategoriesRequestBuilder } from './categories/index.js';
// @ts-ignore
import { CustomersRequestBuilderNavigationMetadata, type CustomersRequestBuilder } from './customers/index.js';
// @ts-ignore
import { InvoicesRequestBuilderNavigationMetadata, type InvoicesRequestBuilder } from './invoices/index.js';
// @ts-ignore
import { OrdersRequestBuilderNavigationMetadata, type OrdersRequestBuilder } from './orders/index.js';
// @ts-ignore
import { PipelineRequestBuilderRequestsMetadata, type PipelineRequestBuilder } from './pipeline/index.js';
// @ts-ignore
import { ProductsRequestBuilderNavigationMetadata, type ProductsRequestBuilder } from './products/index.js';
// @ts-ignore
import { RevenueRequestBuilderNavigationMetadata, RevenueRequestBuilderRequestsMetadata, type RevenueRequestBuilder } from './revenue/index.js';
// @ts-ignore
import { SalesRequestBuilderNavigationMetadata, type SalesRequestBuilder } from './sales/index.js';
// @ts-ignore
import { SalesRepsRequestBuilderNavigationMetadata, type SalesRepsRequestBuilder } from './salesReps/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics
 */
export interface AnalyticsRequestBuilder extends BaseRequestBuilder<AnalyticsRequestBuilder> {
    /**
     * The accessRequests property
     */
    get accessRequests(): AccessRequestsRequestBuilder;
    /**
     * The activeCustomers property
     */
    get activeCustomers(): ActiveCustomersRequestBuilder;
    /**
     * The aov property
     */
    get aov(): AovRequestBuilder;
    /**
     * The carts property
     */
    get carts(): CartsRequestBuilder;
    /**
     * The categories property
     */
    get categories(): CategoriesRequestBuilder;
    /**
     * The customers property
     */
    get customers(): CustomersRequestBuilder;
    /**
     * The invoices property
     */
    get invoices(): InvoicesRequestBuilder;
    /**
     * The orders property
     */
    get orders(): OrdersRequestBuilder;
    /**
     * The pipeline property
     */
    get pipeline(): PipelineRequestBuilder;
    /**
     * The products property
     */
    get products(): ProductsRequestBuilder;
    /**
     * The revenue property
     */
    get revenue(): RevenueRequestBuilder;
    /**
     * The sales property
     */
    get sales(): SalesRequestBuilder;
    /**
     * The salesReps property
     */
    get salesReps(): SalesRepsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AnalyticsRequestBuilderUriTemplate = "{+baseurl}/api/analytics";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AnalyticsRequestBuilderNavigationMetadata: Record<Exclude<keyof AnalyticsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    accessRequests: {
        navigationMetadata: AccessRequestsRequestBuilderNavigationMetadata,
    },
    activeCustomers: {
        requestsMetadata: ActiveCustomersRequestBuilderRequestsMetadata,
    },
    aov: {
        requestsMetadata: AovRequestBuilderRequestsMetadata,
    },
    carts: {
        navigationMetadata: CartsRequestBuilderNavigationMetadata,
    },
    categories: {
        navigationMetadata: CategoriesRequestBuilderNavigationMetadata,
    },
    customers: {
        navigationMetadata: CustomersRequestBuilderNavigationMetadata,
    },
    invoices: {
        navigationMetadata: InvoicesRequestBuilderNavigationMetadata,
    },
    orders: {
        navigationMetadata: OrdersRequestBuilderNavigationMetadata,
    },
    pipeline: {
        requestsMetadata: PipelineRequestBuilderRequestsMetadata,
    },
    products: {
        navigationMetadata: ProductsRequestBuilderNavigationMetadata,
    },
    revenue: {
        requestsMetadata: RevenueRequestBuilderRequestsMetadata,
        navigationMetadata: RevenueRequestBuilderNavigationMetadata,
    },
    sales: {
        navigationMetadata: SalesRequestBuilderNavigationMetadata,
    },
    salesReps: {
        navigationMetadata: SalesRepsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
